const state = {
  articlesList: [],
  articleThemesList: []
}

export default state
